<template>
  <div>
    <!-- search -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <vs-card class="w-full">
      <div class="flex items-center justify-between mb-4">
        <span style="font-size: 18px; font-weight: 500">{{ `입문: ${입문수}명 출문: ${출문수}명 미출문: ${미출문수}명 ` }}</span>
        <vs-button color="secondary" type="border" @click="onClickRefresh">
          <div class="flex gap-2"><feather-icon icon="RotateCwIcon" svgClasses="h-5 w-5" /> 갱신</div>
        </vs-button>
      </div>

      <!-- 로딩 화면 -->
      <div v-if="isLoading" class="loading-container">
        <vs-progress indeterminate color="primary"></vs-progress>
        <p class="loading-text">데이터를 불러오는 중입니다...</p>
      </div>

      <!-- 데이터 테이블 -->
      <div v-else>
        <table>
          <colgroup>
            <col width="80px" />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col width="80px" />
          </colgroup>
          <thead>
            <tr>
              <th>No.</th>
              <th class="sortable" @click="onClickSort('regionName')">
                사업장명
                <span class="sort-icon" v-if="sortKey === 'regionName'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('companyName')">
                업체명
                <span class="sort-icon" v-if="sortKey === 'companyName'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('permitName')">
                공사/작업명
                <span class="sort-icon" v-if="sortKey === 'permitName'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('workPeriod')">
                작업기간
                <span class="sort-icon" v-if="sortKey === 'workPeriod'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('userName')">
                이름
                <span class="sort-icon" v-if="sortKey === 'userName'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('phone')">
                휴대폰번호
                <span class="sort-icon" v-if="sortKey === 'phone'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('enterTime')">
                입문시간
                <span class="sort-icon" v-if="sortKey === 'enterTime'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('exitTime')">
                출문시간
                <span class="sort-icon" v-if="sortKey === 'exitTime'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="sortable" @click="onClickSort('status')">
                구분
                <span class="sort-icon" v-if="sortKey === 'status'">
                  {{ sortOrder === "asc" ? "▲" : "▼" }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="paginatedList.length === 0">
              <td colspan="10" class="empty-message">조회된 데이터가 없습니다.</td>
            </tr>
            <tr v-for="(item, index) in paginatedList" :key="index">
              <td>{{ (page - 1) * perPage + index + 1 }}</td>
              <td>{{ item.regionName }}</td>
              <td>{{ item.companyName }}</td>
              <td>{{ item.permitName }}</td>
              <td>{{ item.workPeriod }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.enterTime }}</td>
              <td>{{ item.exitTime }}</td>
              <td>{{ item.enterTime && !item.exitTime ? "미출문" : item.exitTime ? "출문" : "" }}</td>
            </tr>
          </tbody>
        </table>

        <div class="vs-con-table" v-if="paginatedList.length > 0">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="lastPage" v-model="page" @change="onChangePage"></k-pagination>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    KPagination,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list",
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return 470;
    },
    filteredList() {
      const search = this.nav.value;
      let filtered = [...this.allData];

      // 사업장명 필터 (region_name으로 필터링)
      if (search.field && search.field.fieldName) {
        filtered = filtered.filter((item) => item.regionName && item.regionName === search.field.fieldName);
      }

      // 업체명 필터
      if (search.업체명) {
        filtered = filtered.filter((item) => item.companyName && item.companyName.includes(search.업체명));
      }

      // 이름 필터
      if (search.이름) {
        filtered = filtered.filter((item) => item.userName && item.userName.includes(search.이름));
      }

      // 구분 필터
      if (search.구분) {
        filtered = filtered.filter((item) => {
          if (search.구분 === "입문") {
            // 입문 시간이 존재하는 데이터
            return item.enterTime !== "";
          } else if (search.구분 === "출문") {
            // 출문 시간이 존재하는 데이터
            return item.exitTime !== "";
          } else if (search.구분 === "미출문") {
            // 입문했지만 출문하지 않은 데이터
            return item.enterTime && !item.exitTime;
          }
          return true;
        });
      }

      return filtered;
    },
    sortedList() {
      const sorted = [...this.filteredList];

      if (this.sortKey) {
        sorted.sort((a, b) => {
          let aVal, bVal;

          if (this.sortKey === "status") {
            // 구분 정렬
            aVal = a.enterTime && !a.exitTime ? "미출문" : a.exitTime ? "출문" : "";
            bVal = b.enterTime && !b.exitTime ? "미출문" : b.exitTime ? "출문" : "";
          } else {
            aVal = a[this.sortKey] || "";
            bVal = b[this.sortKey] || "";
          }

          // 문자열 비교
          if (typeof aVal === "string" && typeof bVal === "string") {
            const comparison = aVal.localeCompare(bVal, "ko");
            return this.sortOrder === "asc" ? comparison : -comparison;
          }

          // 일반 비교
          if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
          if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
          return 0;
        });
      }

      return sorted;
    },
    paginatedList() {
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;
      return this.sortedList.slice(start, end);
    },
    stdSearchComponents() {
      const stdSearchComponents = [
        {
          component: "search-select-field",
          label: "사업장명",
          value: "field",
          query: { f_id: "fieldId", f_name: "fieldName" },
          options: {
            default: { fieldId: "", fieldName: "" },
            gridTemplateColumns: "60px 1fr",
          },
        },
        {
          component: "search-date",
          label: "날짜",
          value: "date",
          query: { sd: "date" },
          options: {
            default: new Date().format("yyyy-MM-dd"),
            clearable: false,
            maxDate: new Date().format("yyyy-MM-dd"), // 오늘 날짜까지만 선택 가능
          },
        },
        { component: "empty-space" },
        {
          component: "search-keyword",
          label: "업체명",
          value: "업체명",
          query: { k: "업체명" },
          options: {
            default: "",
            gridTemplateColumns: "60px 1fr",
          },
        },
        {
          component: "search-keyword",
          label: "이름",
          value: "이름",
          query: { k: "이름" },
          options: {
            default: "",
          },
        },
        {
          component: "search-select",
          label: "구분",
          value: "구분",
          query: { k: "select" },
          options: {
            default: "",
            items: [
              { text: "전체", value: "" },
              { text: "입문", value: "입문" },
              { text: "출문", value: "출문" },
              { text: "미출문", value: "미출문" },
            ],
          },
        },
      ];

      for (const component of stdSearchComponents) {
        component.component = searchComponent[component["component"]];
      }

      return stdSearchComponents;
    },
  },
  data() {
    return {
      isPrintMode: false,
      chartData: {},
      nav: {
        value: {
          date: "",
          field: {},
          업체명: "",
          이름: "",
          구분: "",
        },
      },

      page: 1,
      lastPage: 1,
      perPage: 20,
      total: 0,
      allData: [], // API에서 가져온 전체 데이터
      loadingPromise: null, // 진행 중인 API 요청 Promise (중복 호출 방지)
      입문수: 0,
      출문수: 0,
      미출문수: 0,
      isLoading: false,

      // 정렬 관련
      sortKey: "enterTime", // 기본 정렬: 입문시간
      sortOrder: "asc", // 기본 정렬 순서: 오름차순
    };
  },
  watch: {
    page: {
      immediate: true,
      deep: true,
      handler(value) {
        // this.loadHistory();
      },
    },
    "nav.value.date": {
      handler(newVal, oldVal) {
        // 날짜가 변경되면 API 재호출 (갱신 버튼과 동일한 동작)
        if (oldVal !== undefined && newVal !== oldVal) {
          this.loadHistory();
        }
      },
    },
    "nav.value": {
      deep: true,
      handler() {
        // 검색 조건이 변경되면 페이지네이션 업데이트
        this.$nextTick(() => {
          this.updatePagination();
        });
      },
    },
    filteredList: {
      handler() {
        // 필터링된 결과가 변경되면 통계 업데이트
        this.updateStatistics();
      },
    },
  },
  mounted() {
    // this.nav.value.date = new Date().format("yyyy-MM-dd")
    this.loadHistory();
  },
  methods: {
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    onClickSearch() {
      // 검색 버튼 클릭 시 페이지만 1로 초기화하고 필터링은 computed에서 처리
      this.page = 1;
      this.updatePagination();
    },
    onClickRefresh() {
      // 갱신 버튼만 API 재호출
      this.loadHistory();
    },

    onClickSort(key) {
      // 같은 컬럼을 클릭하면 정렬 순서 토글
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        // 다른 컬럼을 클릭하면 해당 컬럼으로 정렬하고 오름차순으로 초기화
        this.sortKey = key;
        this.sortOrder = "asc";
      }
      // 정렬 후 첫 페이지로 이동
      this.page = 1;
    },

    updatePagination() {
      // 정렬된 결과에 따라 페이지네이션 업데이트
      this.total = this.sortedList.length;
      this.lastPage = Math.ceil(this.sortedList.length / this.perPage);

      // 현재 페이지가 마지막 페이지를 넘어가면 조정
      if (this.page > this.lastPage && this.lastPage > 0) {
        this.page = this.lastPage;
      }
    },

    updateStatistics() {
      // 필터링된 데이터를 기반으로 통계 계산
      let enterCount = 0;
      let exitCount = 0;
      let notExitCount = 0;

      for (const item of this.filteredList) {
        if (item.enterTime) {
          enterCount++;
        }
        if (item.exitTime) {
          exitCount++;
        }
        // 미출문: 입문은 했지만 출문하지 않은 경우
        if (item.enterTime && !item.exitTime) {
          notExitCount++;
        }
      }

      this.입문수 = enterCount;
      this.출문수 = exitCount;
      this.미출문수 = notExitCount;
    },

    formatPhone(phone) {
      // 값이 없으면 빈 문자열
      if (!phone) {
        return "";
      }
      // 마스킹된 번호(* 포함)는 그대로 반환
      if (phone.indexOf("*") !== -1) {
        return phone;
      }
      // 숫자만 추출 후 3-4-4 / 3-3-4 형식으로 포맷
      const digits = phone.replace(/[^0-9]/g, "");
      if (digits.length === 11) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
      }
      if (digits.length === 10) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      }
      // 그 외 길이는 원본 그대로 반환
      return phone;
    },

    loadHistory() {
      // 이미 진행 중인 요청이 있으면 해당 Promise를 반환하여 중복 호출 방지
      if (this.loadingPromise) {
        return this.loadingPromise;
      }

      this.isLoading = true;

      const search = this.nav.value;
      const options = {
        params: {
          projectId: this.projId,
          boardIds: [976],
          type: "access",
          // API 호출 시에는 사업장명과 날짜만 전달 (나머지는 클라이언트에서 필터링)
          regionName: search.field && search.field.fieldName ? search.field.fieldName : "",
          dateFrom: search.date ? `${search.date} 00:00:00` : "",
          dateTo: search.date ? `${search.date} 23:59:59` : "",
        },
      };

      this.loadingPromise = HttpRequest.get("/api/v1/project/qr/history/status", options)
        .then((res) => {
          const result = [];

          // 사업장-사람 별로 데이터를 그룹화
          const groupedData = {};

          for (const item of res.data ? res.data : []) {
            const companyName = item.user && item.user.company && item.user.company.com_name ? item.user.company.com_name : "";
            const userName = item.user && item.user.name ? item.user.name : "";
            const phone = item.user && item.user.phone ? this.formatPhone(item.user.phone) : "";
            const userId = item.user && item.user.id ? item.user.id : "";

            const createdAtList = item.created_at_list ? item.created_at_list : [];
            const dataList = item.data_list ? item.data_list : [];
            const regionNameList = item.region_name_list ? item.region_name_list : [];
            const postIdList = item.post_ids ? item.post_ids : [];

            // 공사/작업명 및 작업기간 (permit 정보)
            const permit = item.permit ? item.permit : null;
            const permitName = permit && permit.permit_name ? permit.permit_name : "";
            let workPeriod = "";
            if (permit) {
              if (permit.is_added === true) {
                workPeriod = "당일";
              } else {
                const startDate = permit.start_date ? permit.start_date : "";
                const endDate = permit.end_date ? permit.end_date : "";
                workPeriod = `${startDate} ~ ${endDate}`;
              }
            }

            // 각 QR 스캔 기록을 순회하면서 사업장별로 분리
            for (let index = 0; index < createdAtList.length; index++) {
              const regionName = regionNameList[index] || "";
              const data = dataList[index];
              const createdAt = createdAtList[index];
              const postId = postIdList[index];

              // 사업장-사람 조합으로 고유 키 생성
              const key = `${userId}_${regionName}`;

              if (!groupedData[key]) {
                groupedData[key] = {
                  companyName,
                  permitName,
                  workPeriod,
                  userName,
                  phone,
                  regionName,
                  userId,
                  qrs: [],
                  enterTime: "",
                  exitTime: "",
                };
              }

              // QR 기록 추가
              groupedData[key].qrs.push({
                created_at: createdAt,
                data,
                post_id: postId,
                region_name: regionName,
              });

              // 입문/출문 시간 업데이트
              if (data === "입문") {
                groupedData[key].enterTime = createdAt;
              } else if (data === "출문") {
                groupedData[key].exitTime = createdAt;
              }
            }
          }

          // 그룹화된 데이터를 배열로 변환
          for (const key in groupedData) {
            result.push(groupedData[key]);
          }

          // 전체 데이터를 allData에 저장
          this.allData = result;

          // 통계 및 페이지네이션 업데이트
          this.updateStatistics();
          this.updatePagination();

          this.loadedPage = this.page;

          this.isLoading = false;
        })
        .catch((err) => {
          console.error("QR 스캔 목록 조회 오류:", err);
          this.isLoading = false;
          this.$vs.notify({
            title: "오류",
            text: "QR 스캔 목록을 불러오는 중 오류가 발생했습니다.",
            color: "danger",
            position: "top-right",
          });
        })
        .finally(() => {
          // 요청 완료 후 진행 중 Promise 해제 (다음 호출 허용)
          this.loadingPromise = null;
        });

      return this.loadingPromise;
    },

    onChangePage(page) {},
  },
};
</script>
<style lang="scss" scoped>
h5 {
  font-size: 16px;
  font-weight: 500;
  color: #3c3c3c;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px 7px;
  }

  th {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    background: #f9f9f9;
    position: relative;

    &.sortable {
      cursor: pointer;
      user-select: none;
      transition: background-color 0.2s;

      &:hover {
        background: #e8e8e8;
      }

      .sort-icon {
        margin-left: 4px;
        font-size: 12px;
        color: #666;
      }
    }
  }

  tr.avg td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    background: #f9f9f9;
  }

  tbody tr {
    transition: background-color 0.2s;

    // 홀수 행
    &:nth-child(odd) {
      td {
        background: #ffffff;
      }
    }

    // 짝수 행
    &:nth-child(even) {
      td {
        background: #f8f9fa;
      }
    }

    // 마우스 오버 시
    &:hover {
      td {
        background: #e3f2fd !important;
      }
    }
  }

  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }

  .empty-message {
    padding: 40px 20px;
    color: #999;
    font-size: 15px;
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;

  .loading-text {
    margin-top: 20px;
    font-size: 15px;
    color: #666;
  }
}

.card-grid {
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.responsive-grid {
  grid-template-columns: 1.8fr 1.2fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}
</style>
